import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import moment from 'moment';

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatTime = (time: string | number) => {
  if (!time) {
    return '0 hrs 0 mins 0 secs';
  }

  // Split the time string into parts
  let timeParts = String(time)?.split(':');

  let hours = '0',
    minutes = '0',
    seconds = '0';

  if (timeParts.length === 3) {
    // Format is HH:MM:SS
    [hours, minutes, seconds] = timeParts;
  } else if (timeParts.length === 2) {
    // Format is MM:SS
    [minutes, seconds] = timeParts;
  } else {
    // Invalid format
    return '0 hrs 0 mins 0 secs';
  }

  // Initialize an array to hold the formatted time parts
  let formattedParts: string[] = [];

  // Add "hours" if hours is not 0
  if (parseInt(hours) > 0) {
    formattedParts.push(`${hours} hrs`);
  }

  // Add "minutes" if minutes is not 0
  if (parseInt(minutes) > 0) {
    formattedParts.push(`${minutes} mins`);
  }

  // Add "seconds" if seconds is not 0
  if (parseInt(seconds) > 0) {
    formattedParts.push(`${seconds} secs`);
  }

  // If no time parts are added, return "0 hrs 0 mins 0 secs"
  if (formattedParts.length === 0) {
    return '0 hrs 0 mins 0 secs';
  }

  // Otherwise, join the time parts with spaces and return
  return formattedParts.join(' ');
};

export const formatDateTime = (dateString: any) => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return dayjs
    .utc(dateString)
    .tz(userTimezone || 'UTC')
    .format('MMM DD, YYYY | h:mm A');
};

export const convertToSeconds = (time: any) => {
  const [hours, minutes, seconds] = time?.split(':').map(Number);
  return hours * 3600 + minutes * 60 + seconds;
};

export const convertToHHMMSS = (seconds: number) => {
  const totalSeconds = Math.floor(seconds);
  const hours = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  const pad = (num: number) => String(num).padStart(2, '0');

  return `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
};

export const convertToMMSS = (seconds: number) => {
  return moment().startOf('day').seconds(seconds).format('mm:ss')
};

export const convertToMinutes = (seconds: number): number => {
  return Math.floor(seconds / 60);
};
